import axiosInstance from '../utils/axios';

export const axiosPost = async (url, data, contentType = 'application/json') => {
  let response = {};
  try {
    const result = await axiosInstance.post(url, data, {
      headers: {
        'Content-Type': contentType,
      },
    });
    response = result.data;
    response.success = result.data.success;
    response.msg = result.data.msg;
  } catch (e) {
    response.success = e.success || false;
    response.msg = e.msg || 'something went wrong';
    response.data = e;
  }
  return response;
};

export const axiosGet = async (url, params = {}, contentType = 'application/json') => {
  let response = {};
  try {
    const result = await axiosInstance.get(url, {
      headers: {
        'Content-Type': contentType,
      },
      params,
    });
    response = result.data;
    response.success = result.data.success;
    response.msg = result.data.msg;
  } catch (e) {
    response.success = e.success || false;
    response.msg = e.msg || 'something went wrong';
    response.data = e;
  }
  return response;
};

export const axiosPatch = async (url, data, contentType = 'application/json') => {
  let response = {};
  try {
    const result = await axiosInstance.patch(url, data, {
      headers: {
        'Content-Type': contentType,
      },
    });
    response = result.data;
    response.success = result.data.success;
    response.msg = result.data.msg;
  } catch (e) {
    response.success = e.success || false;
    response.msg = e.msg || 'something went wrong';
    response.data = e;
  }
  return response;
};

export const axiosDelete = async (url, params = {}, contentType = 'application/json') => {
  let response = {};
  try {
    const result = await axiosInstance.delete(url, {
      headers: {
        'Content-Type': contentType,
      },
      params,
    });
    response = result.data;
    response.success = result.data.success;
    response.msg = result.data.msg;
  } catch (e) {
    response.success = e.success || false;
    response.msg = e.msg || 'something went wrong';
    response.data = e;
  }
  return response;
};
